<template>
    <div>
        <div class="form-group">
              <label>{{ __('forms.RecruitingChart.applicant') }}</label>
              <select class="form-control" @change="changeStatusSet($event)"  name="recruitingChart[person_id]" required>
                    <option value="">---</option>
                    <optgroup :label="__('forms.subModels.recruitingApplicant')">
                      <option v-for="applicantPeople in people['applicant']" :value="applicantPeople.id">
                          {{applicantPeople.fullName}}
                      </option>
                    </optgroup>
                    <optgroup :label="__('forms.subModels.employee')">
                      <option v-for="employeePeople in people['employee']" :value="employeePeople.id">
                          {{employeePeople.fullName}}
                      </option>
                    </optgroup>
              </select>
        </div>
        <div class="form-group">
            <label>{{ __('forms.RecruitingChart.status') }}</label>
            <select class="form-control" name="recruitingChart[status_id]" required >
                <option v-for="status in statuses" :value="status.id">
                    {{ status.name }}
                </option>
            </select>
        </div>
    </div>
  </template>

<script>
    export default {
        data(){
            return {
                statuses : {},
            }
        },
        mounted() {
            //
        },
        props: {

            people :{
                type: Object,
                required : true
            },
            recruiting_campaign_id :{
                type: Number,
                required : true
            }

        },
        methods: {
            changeStatusSet(event){

                let person_id = event.target.value;
                axios.get("/recruiting-charts-create-get-statuses-workflow-by-person/"+this.recruiting_campaign_id+"/recruiting-campaign",
                    { params: {
                            "person_id" : person_id
                        }
                    }
                )
                    .then((response) => {
                        this.statuses = response.data;
                    });

            }
        }
    }
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
